module.exports = __webpack_public_path__ + "img/0003.7da250e2.jpg";